














import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class TitleAndMessage extends Vue {
  @Prop({default: () => '', required: false}) title: string | string[]
  @Prop({default: '', required: false, type: String}) message: string

  get titleList(): string[] {
    return typeof this.title === 'string' ? [this.title] : this.title
  }
}
